var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 3.125V1.875M4.6875 3.125V1.875M2.03125 5H12.9688M1.875 6.2775C1.875 4.95562 1.875 4.29438 2.1475 3.78938C2.3939 3.33894 2.77625 2.97781 3.24 2.7575C3.775 2.5 4.475 2.5 5.875 2.5H9.125C10.525 2.5 11.225 2.5 11.76 2.7575C12.2306 2.98375 12.6125 3.345 12.8525 3.78875C13.125 4.295 13.125 4.95625 13.125 6.27813V9.34812C13.125 10.67 13.125 11.3312 12.8525 11.8362C12.6061 12.2867 12.2238 12.6478 11.76 12.8681C11.225 13.125 10.525 13.125 9.125 13.125H5.875C4.475 13.125 3.775 13.125 3.24 12.8675C2.77634 12.6473 2.39401 12.2865 2.1475 11.8362C1.875 11.33 1.875 10.6687 1.875 9.34687V6.2775Z",
    stroke: "#888888",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIcon);
export default __webpack_public_path__ + "static/media/skills_icon.dcc7a20c26d6e668d5f36a5944593a2f.svg";
export { ForwardRef as ReactComponent };